import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ThemeToggle } from './components/ThemeToggle';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AccountPage } from './pages/AccountPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { RoomWatchPage } from './pages/RoomWatchPage';
import { RoomsPage } from './pages/RoomsPage';
import { UploadPage } from './pages/UploadPage';
import { WatchPage } from './pages/WatchPage';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/upload"
              element={<ProtectedRoute><UploadPage /></ProtectedRoute>}
            />
            <Route
              path="/rooms"
              element={<ProtectedRoute><RoomsPage /></ProtectedRoute>}
            />
            <Route
              path="/rooms/:id"
              element={<ProtectedRoute><RoomWatchPage /></ProtectedRoute>}
            />
            <Route
              path="/account"
              element={<ProtectedRoute><AccountPage /></ProtectedRoute>}
            />
            <Route path="/watch/:id" element={<WatchPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ThemeToggle />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
